import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { FetchAgencyPlanManagement, FetchStripeCreateSession, PostStripeCreateSession } from "../../api/helper";

const SubscriptionVerify = ({ info, getDteails, appointmentdetail }) => {
  const [activeplan, setactiveplan] = useState([]);
  const [upgradeplanmodal, setupgradeplanmodal] = useState(false);
  const [detailsmodal, setdetailsmodal] = useState(false);
  const [activeTab, setActiveTab] = useState("biweekly");
  const [plans, setPlans] = useState([]);
  const [enrollModalData, setEnrollModalData] = useState(null);
  const [enrollalldata, setenrollalldata] = useState(null);
  const [detailsModalData, setDetailsModalData] = useState(null);
  const [modal, setmodal] = useState(false);

  const switchTab = (tab) => {
    console.log("click-0-0-0-0-0-");
    setActiveTab(tab);
  };
    const closeDetailsModal = () => {
    setDetailsModalData(null);
  };
  const filterPlansByType = (type) => {
    return plans.filter(
      (plan) => plan.planType.toLowerCase() === type.toLowerCase()
    );
  };
  const openEnrollModal = (planName, price, plan) => {
    setEnrollModalData({ planName, price });
    setenrollalldata(plan);
  };

  const closeEnrollModal = () => {
    setEnrollModalData(null);
    setenrollalldata(null);
  };
  const openDetailsModal = (planName, price, frequency, services) => {
    setDetailsModalData({ planName, price, frequency, services });
  };
    const GetActivePlan = async () => {
      const data = {
        patientId: info?.patientId?._id,
        agencyId: info?.agencyId?._id,
      };
      try {
        const respo = await FetchStripeCreateSession(data);
        setactiveplan(respo?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };
      const fetchData = async () => {
        try {
          const respones = await FetchAgencyPlanManagement(
            info?.agencyId?._id,
            "subscription"
          );
          setPlans(respones.data.data);
        } catch (error) {
          console.log(error, "===>>");
        }
      };
        const PostStripe = async (id) => {
          if (!info?.agencyId?.isConnctedStripe) {
            setmodal(true);
            return;
          }
          const data = {
            planId: id,
            patientId: info?.patientId?._id,
            patientRequestId: info?._id,
            agencyId: info?.agencyId?._id,
          };
          try {
            const respo = await PostStripeCreateSession(data);
            window.location.href = respo?.data?.data;
            closeEnrollModal();
          } catch (error) {
            console.log(error);
          }
        };
    useEffect(() => {
        fetchData()
      GetActivePlan();
    }, []);
  return (
    <div id="subscriptionFields" style={{ marginTop: "1rem" }}>
  
      {activeplan.length > 0 ? (
        <div
          className="membership-card_MemberPlan"
          style={{ alignSelf: "center" }}
        >
          <div className="card-header_MemberPlan">
            <div className="program-name">Direct Care Membership</div>
            <div className="membership-status_MemberPlan active">Active</div>
          </div>
          <div className="card-content_MemberPlan">
            <div className="info-group">
              <div className="label_MemberPlan">Member Name</div>
              <div className="value_MemberPlan">
                {activeplan[0]?.patientId?.firstName +
                  " " +
                  activeplan[0]?.patientId?.lastName}
              </div>
            </div>
            <div className="info-group">
              <div className="label_MemberPlan">Membership ID</div>
              <div className="value_MemberPlan">
                {activeplan[0]?.membershipId}
              </div>
            </div>
            <div className="info-group">
              <div className="label_MemberPlan">Plan Name</div>
              <div className="value_MemberPlan">
                {activeplan[0]?.planId?.PlanName}
              </div>
            </div>
            <div className="info-group">
              <div className="label_MemberPlan">Effective Date</div>
              <div className="value_MemberPlan">
                {format(activeplan[0]?.startDate, "MM-dd-yyyy")}
              </div>
            </div>
            <div className="info-group">
              <div className="label_MemberPlan">Fee</div>
              <div className="value_MemberPlan">
                ${activeplan[0]?.planId?.fee} /{" "}
                {activeplan[0]?.planId?.planType}
              </div>
            </div>
            <div className="info-group">
              <div className="label_MemberPlan">Benefits Used</div>
              <div className="progress-bar_MemberPlan">
                <div className="progress_MemberPlan" style={{ width: "5%" }} />
              </div>
              <div className="progress-text_MemberPlan">5% Used</div>
            </div>
          </div>
          <div className="action-buttons_MemberPlan">
            <button
              onClick={() => {
                setupgradeplanmodal(true);
              }}
                type="button"
            >
              Upgrade Plan
            </button>
            <button
              onClick={() => {
                setdetailsmodal(true);
              }}
               type="button"
            >
              Plan Details
            </button>
            <button   type="button">Renew</button>
          </div>
          <div className="card-footer_MemberPlan">
            <span>
              Member Support: <span>1-800-DPC-CARE</span>
            </span>
            <span className="card-number_MemberPlan">
              Phone #: {"profiledata?.phone"}
            </span>
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="tabs_MemberPlan">
              {["biweekly", "monthly", "biannually", "annually"].map((tab) => (
                <button
                  type="button"
                  key={tab}
                  className={`tab-button_MemberPlan ${
                    activeTab === tab ? "active" : ""
                  }`}
                  onClick={() => switchTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </div>

          {["biweekly", "monthly", "biannually", "annually"].map((tab) => (
            <div
              key={tab}
              className={`plans-container_MemberPlan ${
                activeTab === tab ? "active" : ""
              }`}
            >
              {filterPlansByType(tab).length === 0 ? (
                <div className="no-plans-message_MemberPlan">
                  No {tab.charAt(0).toUpperCase() + tab.slice(1)} Subscription
                  Plan available
                </div>
              ) : (
                filterPlansByType(tab).map((plan) => {
                  const isSubscribed = activeplan.some(
                    (active) => active.planId?._id === plan._id
                  );
                  return (
                    <div key={plan._id} className="plan-card_MemberPlan">
                      {isSubscribed && (
                        <span style={{ color: "Green", fontWeight: "bold" }}>
                          {" "}
                          Active
                        </span>
                      )}

                      <div className="plan-title_MemberPlan">
                        {plan.PlanName}
                      </div>
                      {plan?.serviceType && (
                        <div>
                          <strong>Service Type:</strong>
                          <br />
                          {plan?.serviceType}
                        </div>
                      )}
                      <div className="plan-frequency_MemberPlan">{`Charged ${plan.planType.toLowerCase()}`}</div>
                      <div className="plan-price_MemberPlan">{`$${plan.fee} / ${
                        tab.charAt(0).toUpperCase() + tab.slice(1)
                      }`}</div>
                      <ul className="features_MemberPlan">
                        <li>
                          <i className="fas_MemberPlan fa-user-md" />
                          {plan?.Benefits}
                        </li>
                      </ul>
                      <div className="cta-buttons_MemberPlan">
                        <button
                          type="button"
                         className="enroll-btn"
                          onClick={() =>
                            openEnrollModal(plan.PlanName, `$${plan.fee}`, plan)
                          }
                        >
                          Enroll
                        </button>
                        <button
                          type="button"
                          className="details-btn"
                          onClick={() =>
                            openDetailsModal(
                              plan.PlanName,
                              `$${plan.fee}`,
                              plan.planType,
                              plan.AddIndividualItems.map((item) => ({
                                service: item.item,
                                unit: item.count,
                              }))
                            )
                          }
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          ))}
        </>
      )}
            {upgradeplanmodal && (
        <div className="new_modal_upgrade_plan">
          <div
            style={{
              width: "80%",
              maxWidth: 800,
              minWidth: "300px",
              backgroundColor: "white",
              paddingTop: 20,
              paddingBottom: 20,
              height: "90vh",
              borderRadius: 10,
              overflow: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
                {/* <div className="interval-toggle">
              <button
                type="button"
                data-interval="biweekly"
                className="interval-btn active"
              >
                Biweekly
              </button>
              <button
                type="button"
                data-interval="monthly"
                className="interval-btn"
              >
                Monthly
              </button> */}
              <div className="interval-toggle">
                {["biweekly", "monthly", "biannually", "annually"].map(
                  (tab) => (
                    <button
                    type="button"
                      key={tab}
                      className={`interval-btn ${
                        activeTab === tab ? "active" : ""
                      }`}
                      onClick={() => switchTab(tab)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
            </div>

            {["biweekly", "monthly", "biannually", "annually"].map((tab) => (
              <div
                key={tab}
                className={`plans-container_MemberPlan ${
                  activeTab === tab ? "active" : ""
                }`}
              >
                {filterPlansByType(tab).length === 0 ? (
                  <div className="no-plans-message_MemberPlan">
                    No {tab.charAt(0).toUpperCase() + tab.slice(1)} Subscription
                    Plan available
                  </div>
                ) : (
                  filterPlansByType(tab).map((plan) => {
                    const isSubscribed = activeplan.some(
                      (active) => active.planId?._id === plan._id
                    );
                    return (
                      <div key={plan._id} className="plan-card_MemberPlan">
                        {isSubscribed && (
                          <span style={{ color: "Green", fontWeight: "bold" }}>
                            {" "}
                            Active
                          </span>
                        )}
                        <div className="plan-title_MemberPlan">
                          {plan.PlanName}
                        </div>
                        {plan?.serviceType && (
                          <div>
                            <strong>Service Type:</strong> {plan?.serviceType}
                          </div>
                        )}
                        <div className="plan-frequency_MemberPlan">{`Charged ${plan.planType.toLowerCase()}`}</div>
                        <div className="plan-price_MemberPlan">{`$${
                          plan.fee
                        } / ${
                          tab.charAt(0).toUpperCase() + tab.slice(1)
                        }`}</div>
                        <ul className="features_MemberPlan">
                          <li>
                            <i className="fas_MemberPlan fa-user-md" />
                            {plan?.Benefits}
                          </li>
                        </ul>
                        <div className="cta-buttons_MemberPlan">
                          <button
                            type="button"
                           className="enroll-btn"
                            onClick={() => {
                              setupgradeplanmodal(false);
                              openEnrollModal(
                                plan.PlanName,
                                `$${plan.fee}`,
                                plan
                              );
                            }}
                          >
                            Enroll
                          </button>
                          <button
                            type="button"
                         className="details-btn"
                            onClick={() => {
                              setupgradeplanmodal(false);
                              openDetailsModal(
                                plan.PlanName,
                                `$${plan.fee}`,
                                plan.planType,
                                plan.AddIndividualItems.map((item) => ({
                                  service: item.item,
                                  unit: item.count,
                                }))
                              );
                            }}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            ))}
            <button
              type="button"
              className="close-button_MemberPlan"
              onClick={() => {
                setupgradeplanmodal(false);
              }}
            >
              Cancel Upgrade
            </button>
          </div>
        </div>
      )}
            {detailsmodal && (
        <div className="modal_MemberPlan">
          <div className="modal-content_MemberPlan">
            <h2>{activeplan[0]?.planId?.PlanName}</h2>
            <p>
              <strong>Price:</strong> {activeplan[0]?.planId?.fee}
            </p>
            <p>
              <strong>Frequency:</strong>
              {activeplan[0]?.planId?.planType}
            </p>
            <p>
              <strong>Benefits:</strong>
              {activeplan[0]?.planId?.Benefits}
            </p>
            <table>
              <thead>
                <tr>
                  <th>Individual Items</th>
                  <th>count</th>
                </tr>
              </thead>
              <tbody>
                {activeplan[0]?.planId?.AddIndividualItems.map(
                  (service, index) => (
                    <tr key={index}>
                      <td>{service.item}</td>
                      <td>{service.count}</td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
            <button
              type="button"
              className="close-button_MemberPlan"
              onClick={() => {
                setdetailsmodal(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
           {enrollModalData && (
        <div className="modal_MemberPlan">
          <div className="modal-content_MemberPlan">
            <h2>Enroll in Plan</h2>
            <p>
              <strong>Plan:</strong> {enrollModalData.planName}
            </p>
            <p>
              <strong>Price:</strong> {enrollModalData.price}
            </p>

            {info?.patientCards?.length > 0 ? (
              info.patientCards.map((card) => (
                <div key={card._id} className="payment-options_MemberPlan">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: "70%" }}>
                      Card ending in {card.cardNumber.slice(-4)}
                    </label>
                    <input type="radio" name="payment-method" value="card1" />
                  </div>
                </div>
              ))
            ) : (
              <p>No cards available.</p>
            )}

            <div
              id="card-element_MemberPlan"
              className="element_MemberPlan"
              style={{ display: "none" }}
            />
            <button
              type="button"
              className="cta-button_MemberPlan"
              onClick={() => {
                PostStripe(enrollalldata?._id);
              }}
            >
              Confirm Enrollment
            </button>
            <button
              type="button"
              className="close-button_MemberPlan"
              onClick={closeEnrollModal}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {detailsModalData && (
        <div className="modal_MemberPlan">
          <div className="modal-content_MemberPlan">
            <h2>{detailsModalData.planName}</h2>
            <p>
              <strong>Price:</strong> {detailsModalData.price}
            </p>
            <p>
              <strong>Frequency:</strong> {detailsModalData.frequency}
            </p>

            <table>
              <thead>
                <tr>
                  <th>Individual Items</th>
                  <th>count</th>
                </tr>
              </thead>
              <tbody>
                {detailsModalData.services.map((service, index) => (
                  <tr key={index}>
                    <td>{service.service}</td>
                    <td>{service.unit}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button
              type="button"
              className="close-button_MemberPlan"
              onClick={closeDetailsModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionVerify;
